module.exports = __webpack_public_path__ + "static/media/feature-scale.01475fa4.png";